export const translations = {
  cnpjInvalido: {
    pt: 'CNPJ/CPF Inválido',
    en: 'Invalid CNPJ/CPF',
    de: 'CNPJ/CPF ungültig',
    es: 'CNPJ/CPF no válido',
  },
  obrigatorio: {
    pt: 'Obrigatório',
    en: 'Mandatory',
    de: 'Pflichtfeld',
    es: 'Obligatorio',
  },
  cnpj: {
    pt: 'CNPJ',
    en: 'CNPJ',
    de: 'CNPJ',
    es: 'Numero de Identificacion',
  },
  idExterior: {
    pt: 'ID Exterior',
    en: 'Foreign ID',
    de: 'ID Ausland',
    es: 'DNI extranjero',
  },
  emailInvalido: {
     pt: 'Email inválido',
     en: 'Invalid email',
     de: 'Ungültige E-Mail-Adresse',
     es: 'Email inválido',
  },
  codigoInvalido: {
     pt: 'Código inválido',
     en: 'Invalid code',
     de: 'Ungültiger Code',
     es: 'Codigo invalido',
  },
  CEPnaoEncontrado: {
     pt: 'CEP não encontrado',
     en: 'CEP not found',
     de: 'Postleitzahl nicht gefunden',
     es: 'CEP no encontrado',
  },
  CEPInvalido: {
     pt: 'CEP inválido',
     en: 'Invalid zip code',
     de: 'Ungültige Postleitzahl',
     es: 'Código postal no válido',
  },
 configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novoCliente: {
    pt: 'Novo cliente',
    en: 'New customer',
    de: 'Neuer Kunde',
    es: 'Nuevo cliente',
  },
  voltar: {
    pt: 'Voltar',
    en: 'Go back',
    de: 'Zurück',
    es: 'Regresa',
  },
  estrangeiro: {
    pt: 'Estrangeiro',
    en: 'Foreign',
    de: 'Ausland',
    es: 'Extranjero',
  },
  nacional: {
    pt: 'Nacional',
    en: 'Nacional',
    de: 'Inland',
    es: 'Nacional',
  },
  razaoSocial: {
    pt: 'Razão Social',
    en: 'Social Reason',
    de: 'Firmenname',
    es: 'Razón Social',
  },
  nomeFantasia: {
    pt: 'Nome Fantasia',
    en: 'Fantasy name',
    de: 'Fantasiename',
    es: 'Nombre de fantasía',
  },
  codigoSAP: {
    pt: 'Código SAP',
    en: 'SAP code',
    de: 'SAP-Code',
    es: 'código SAP',
  },
  segmentacao: {
    pt: 'Customer segmentation',
    en: 'Customer segmentation',
    de: 'Kundensegmentierung',
    es: 'Segmentación de clientes',
  },
  inscricaoEstatual: {
    pt: 'Inscrição Estadual',
    en: 'State registration',
    de: 'Staatliche Registrierung',
    es: 'Registro estatal',
  },
  telefone: {
    pt: 'Telefone',
    en: 'Telephone',
    de: 'Telefon',
    es: 'Teléfono',
  },
  email: {
    pt: 'E-mail',
    en: 'E-mail',
    de: 'E-mail',
    es: 'Correo electrónico',
  },
  cep: {
    pt: 'Cep',
    en: 'Zip code',
    de: 'Postleitzahl',
    es: 'Código postal',
  },
  postalCode:{
    pt: "Código postal",
    en: "Zip code",
    de: "Postleitzahl",
    es: 'Código postal',
  },
  uf: {
    pt: 'UF',
    en: 'Federative unit',
    de: 'Bundesstaat',
    es: 'Estado/Provincia',
  },
  provincy:{
    pt: "Província",
    en: "State",
    de: "Länder",
    es: "Província"
  },
  lougradouro: {
    pt: 'Logradouro',
    en: 'Public place',
    de: 'Adresse',
    es: 'Direccion',
  },
  numero: {
   pt: 'Número',
   en: 'Number',
   de: 'Hausnummer',
   es: 'Número',
  },
  bairro: {
    pt: 'Bairro',
    en: 'Neighborhood',
    de: 'Stadtviertel',
    es: 'Barrio',
  },
  cidade: {
   pt: 'Cidade',
   en: 'City',
   de: 'Ort',
   es: 'Ciudad',
  },
  latitude: {
   pt: 'Latitude',
   en: 'Latitude',
   de: 'Breitengrad',
   es: 'Latitud',
  },
  longitude: {
   pt: 'Longitude',
   en: 'Longitude',
   de: 'Längengrad',
   es: 'Longitud',
  },
  necessitaAgendamento: {
    pt: 'Necessita agendamento',
    en: 'Need scheduling',
    de: 'Terminplanung erforderlich',
    es: 'Necesita programar',
  },
  infoEntrega: {
    pt: 'Informações de entrega:',
    en: 'Delivery information:',
    de: 'Informationen zur Lieferung:',
    es: 'Información de entrega:',
  },
  segunda:{
    pt: 'Segunda',
    en: 'Monday',
    de: 'Montag',
    es: 'Lunes',
  },
  terca:{
    pt: 'Terça',
    en: 'Tuesday',
    de: 'Dienstag',
    es: 'Martes',
  },
  quarta:{
    pt: 'Quarta',
    en: 'Wednesday',
    de: 'Der Mittwoch',
    es: 'Miércoles',
  },
  quinta:{
    pt: 'Quinta',
    en: 'Thursday',
    de: 'Donnerstag',
    es: 'Jueves',
  },
  sexta:{
    pt: 'Sexta',
    en: 'Friday',
    de: 'Freitag',
    es: 'Viernes',
  },
  sabado:{
    pt: 'Sábado',
    en: 'Saturday',
    de: 'Samstag',
    es: 'Sábado',
  },
  domingo:{
    pt: 'Domingo',
    en: 'Sunday',
    de: 'Sonntag',
    es: 'Domingo',
  },
  inicioRecebimento:{
    pt: 'Início de recebimento',
    en: 'Start of receipt',
    de: 'Beginn des Empfangs',
    es: 'Inicio de recepcion',
  },
  fimRecebimento:{
    pt: 'Fim de recebimento',
    en: 'End of receipt',
    de: 'Ende der Quittung',
    es: 'Fin de recepcion',
  },
  inicioRefeicao:{
    pt: 'Início de refeição',
    en: 'Meal start',
    de: 'Beginn der Mahlzeit',
    es: 'Comienzo horario de almuerzo',
  },
  fimRefeicao:{
    pt: 'Fim de refeição',
    en: 'End of meal',
    de: 'Ende der Mahlzeit',
    es: 'Fin horario de almuerzo',
  },
  observacao: {
    pt: 'Observação',
    en: 'Observation',
    de: 'Anmerkung',
    es: 'Observación',
  },
  cancelar: {
    pt: 'Cancelar',
    en: 'Cancel',
    de: 'Abbrechen',
    es: 'Cancelar',
  },
  cadastrar: {
    pt: 'Salvar',
    en: 'Save',
    de: 'Speichern',
    es: 'Guardar',
  },
  editarCliente: {
    pt: 'Editar cliente',
    en: 'Edit customer',
    de: 'Kunde bearbeiten',
    es: 'Editar cliente',
  },
  selecione: {
    pt: 'Selecione...',
    en: 'Select...',
    de: 'Wählen Sie...',
    es: 'Seleccione...',
  },
  IdExterior: {
    pt: 'Id Exterior',
    en: 'External ID',
    de: 'Externe ID',
    es: 'ID externa',
  },
  pais: {
    pt: "País",
    en: "Country",
    de: "Land",
    es: "País",
  },
};